<template>
	<Modal width="980" title="涉及请假课程" v-model="visible" >
    <Table class="compact" size="small" :columns="tchLeaveLessonColumn"
      :data="bookLessonOpenedList"></Table>
    <div slot="footer" ></div>
  </Modal>
</template>
<script>
  import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
export default {
    name: 'TchLeaveLessonModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      tchId: {
        type: Number,
        default: null
      },
      startTime: {
        type: Number,
        default: null
      },
      endTime: {
        type: Number,
        default: null
      },
      lsnSelStatus: {
        type: Number,
        default: null
      },
    },
    data () {
      let $constant = this.$constant
      let $moment = this.$moment
      return {
      rankScoreSeq: 0,
        visible: this.value,
        bookLessonOpenedList: [],
        tchLeaveLessonColumn: [
          {
            title: '学生ID、姓名',
            width: 100,
            render: (h, params) => {
              let row = params.row
              return h('div', [
                h('span', row.uid),
                h('br', '  '),
                h('span', row.userNickname || '')
              ])
            }
          },
          {
            title: '老师ID、姓名',
            width: 180,
            render: (h, params) => {
              let row = params.row
              return renderTchNameWithScore(h, {
                text: row.tchId + ' - ' + ((row.tchFirstName || '') + ' ' + (row.tchLastName || '')).trim(),
                score: row.monthRankScore
              })
            }
          },
          {
            title: '老师账号',
            width: 100,
            key: 'tchEmail'
          },
          {
            title: '外教运营',
            width: 90,
            key: 'tchStudyAdviserNickname'
          },
          {
            title: '学顾',
            width: 90,
            key: 'studyAdviserNickname'
          },
          {
            title: '课程类型',
            align: 'center',
            width: 72,
            render: (h, params) => {
              let lsnType = params.row.lsnType
              let typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType)
              return h('span', typeEnum && typeEnum.text)
            }
          },
          {
            title: '课程名称',
            key: 'lessonTitle'
          },
          {
            title: '开始、结束时间',
            align: 'center',
            width: 122,
            render: (h, params) => {
              let lsnBeginTime = params.row.lsnBeginTime
              let lsnEndTime = params.row.lsnEndTime
              return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm') + ' ' + $moment(lsnEndTime, 'X').format('YYYY-MM-DD HH:mm'))
            }
          },
          {
            title: '上课时长',
            align: 'center',
            width: 72,
            key: 'courseTime'
          },
          {
            title: '上课状态',
            width: 72,
            render: (h, params) => {
              let lsnSelStatus = params.row.lsnSelStatus
              let statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus)
              return h('span', statusEnum && statusEnum.text)
            }
          },
          {
            title: '是否代课',
            align: 'center',
            width: 72,
            render: (h, params)=> {
              let oldTch = params.row.oldOpenedId
              if(oldTch > 0){
                return h('div', '是')
              }else {
                return h('div', '否')
              }
            }
          }
        ],
        tchLeaveLessonList: []
      }
    },
    methods: {
    loadMonthRankScores () {
      const table = this.bookLessonOpenedList
      if (!table || !table.length) {
        return
      }
      const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
      })
    },

      loadTchLeaveLesson () {
        let self = this
        let params = {}
        params.tchId = this.tchId
        params.startTime = this.startTime
        params.endTime = this.endTime
        params.lsnSelStatus=this.lsnSelStatus

        self.$http.get('/bookLesson/tchLeave/list', { params: params }).then(function (res) {
          self.bookLessonOpenedList = res.data
          self.loadMonthRankScores()
        })
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === true) {
          this.bookLessonOpenedList = []
          this.loadTchLeaveLesson()
        }
        this.$emit('input', val)
      }
    }
  }

</script>



// WEBPACK FOOTER //
// TchLeaveLessonModal.vue?dd7e3398